<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["barChartDataset", "barChartLabels"],
  mounted() {
    this.renderChart(
      {
        labels: this.barChartLabels,
        datasets: this.barChartDataset,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: "white",
            // This more specific font property overrides the global property
            // font: {
            //   size: 14,
            // },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "white",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "white",
              },
            },
          ],
        },
      }
    );
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Charts/BarChart.vue